export const HttpMethod = {
    GET : 'GET',
    PUT : 'PUT',
    POST : 'POST',
    DELETE : 'DELETE'
  }

  export const LanguageList : any= {
    "en":"English",
    "ma": "मराठी",
    "hi": "हिन्दी"
  }